import type { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';

import { useLayout } from '../../main/util/layout-context';
import { useDesktop } from '../../shared/hooks/breakpoint';
import { createClassName, createStyleHelper } from '../../shared/utils/class-names';

import styles from './registration.module.scss';

const style = createStyleHelper(styles, 'registration');

export interface IRegistrationLayoutProps {
    className?: string;
}

export const RegistrationLayout: FunctionComponent<IRegistrationLayoutProps> = ({ className }) => {
    const isFullDisplay = useDesktop();
    useLayout({
        showNavButtons: false,
    });

    return (
        <div className={createClassName([className, style()])}>
            {!isFullDisplay ? (
                <div className={style('heading')}>
                    {/*<FormattedMessage*/}
                    {/*    id="registration.step-one.heading-title.heading"*/}
                    {/*    defaultMessage="Join now and benefit from rewards and bonus offers"*/}
                    {/*/>*/}
                </div>
            ) : null}
            <Outlet />
        </div>
    );
};
